import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;

export const saveEndorsement = createAsyncThunk(
  "endorsement/saveEndorsement",
  async (params, { rejectWithValue }) => {
    try {
      params.authorization = localStorage.getItem("userToken");
      const response = await axios.post(`${BASE_URL}/Endorsement/endorsement`, params);
      const data = await response.data;
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);